export const formatNumberWithCommas =(number) => {
    if (typeof number === 'string') {
        number = parseFloat(number.replace(/,/g, ''));
    }
    return number.toLocaleString();
}
